<div class="categories-container">
    <div class="categories-content"
        *ngIf="page"
        [innerHtml]="content">
    </div>
    <div class="navigation-content">
        <h4 *ngIf="parent" (click)="backToMain();"><< wróć do głównej</h4>
    </div>
    <div class="categories">
        <div class="category-brick"
            *ngFor="let category of categories; let i = index"
            [ngClass]="'category-brick-'+i"
            [style.background]="category.background"
            [style.color]="category.color"
            [style.width]="'calc('+category.width+'% - '+(category.padding * 2)+'px)'"
            [style.paddingLeft]="category.padding+'px'"
            [style.paddingRight]="category.padding+'px'"
            (click)="follow(category);">
            <div fittext>
                {{ category.name }}
            </div>            
        </div>
        <!-- <div *ngIf="!parent" routerLink="/czujki" class="category-brick category-brick-czujki">
            <div fittext>
                Czujki
            </div>            
        </div>
        <div *ngIf="!parent" routerLink="/domusie" class="category-brick category-brick-domusie">
            <div fittext>
                Domusie
            </div>            
        </div>
        <div *ngIf="!parent" routerLink="/niebyleczo" class="category-brick category-brick-niebyleczo">
            <div fittext>
                Niebyleczo
            </div>            
        </div>  -->
    </div>
</div>
